export const profileSectionStyles = {
  card: {
    borderRadius: 3,
    boxShadow: theme => 
      theme.palette.mode === 'dark'
        ? '0 2px 12px rgba(0,0,0,0.3)'
        : '0 2px 12px rgba(0,0,0,0.08)',
    height: '100%',
    border: '1px solid',
    borderColor: theme =>
      theme.palette.mode === 'dark' ? 'grey.700' : 'grey.200',
    backgroundColor: theme =>
      theme.palette.mode === 'dark' ? 'grey.800' : 'white',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: theme =>
        theme.palette.mode === 'dark'
          ? '0 8px 25px rgba(0,0,0,0.4)'
          : '0 8px 25px rgba(0,0,0,0.15)',
      transform: 'translateY(-4px)',
    },
  },

  header: {
    borderBottom: '1px solid',
    borderColor: theme =>
      theme.palette.mode === 'dark' ? 'grey.700' : 'grey.100',
    p: 3,
  },

  getHeaderBackground: (color) => ({
    background: theme =>
      theme.palette.mode === 'dark'
        ? `linear-gradient(135deg, ${color}25 0%, ${color}10 100%)`
        : `linear-gradient(135deg, ${color}15 0%, ${color}05 100%)`,
  }),

  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  iconContainer: {
    p: 1.5,
    borderRadius: 2,
    backgroundColor: theme =>
      theme.palette.mode === 'dark' ? 'grey.900' : 'white',
    mr: 2,
    boxShadow: theme =>
      theme.palette.mode === 'dark'
        ? '0 2px 8px rgba(0,0,0,0.3)'
        : '0 2px 8px rgba(0,0,0,0.1)',
  },

  title: {
    fontWeight: 700,
    color: 'text.primary',
  },

  content: {
    p: 3,
  },
}; 